<template>
  <div
    class="package-new__tab flex column wc-lg"
    :class="{ 'first-tab': tab_index === 0 }"
  >
    <div class="package-new__row flex a_center j_center first-tab-row">
      <h2
        class="f-16 regular"
        v-if="tab_index !== 0"
        :class="{ bold: tab_index !== 0 }"
      >
        {{ tab.title }}
      </h2>
    </div>
    <div
      class="package-new__row flex a_center"
      v-for="(item, i) in tab.content.tabs"
      :key="i"
      :class="{
        bg_gray_2: (i + 1) % 2 == 0,
        'other-tab-row': tab_index !== 0,
      }"
    >
      <div class="flex">
        <div
          class="package-new__tab--checkbox checked"
          v-if="tab_index !== 0 && item.check[0] === 'yes'"
        ></div>
        <svg
          v-if="tab_index !== 0 && item.check[0] === 'no'"
          id="Component_37_347"
          data-name="Component 37 – 347"
          xmlns="http://www.w3.org/2000/svg"
          width="24.942"
          height="24.942"
          viewBox="0 0 24.942 24.942"
          class="package-new__x"
        >
          <g id="Group_3571" data-name="Group 3571">
            <g id="Path_1464" data-name="Path 1464" fill="none">
              <path
                d="M9,0h6.951a9,9,0,0,1,9,9v6.951a9,9,0,0,1-9,9H9a9,9,0,0,1-9-9V9A9,9,0,0,1,9,0Z"
                stroke="none"
              />
              <path
                d="M 8.995402336120605 1.000001907348633 C 4.586721420288086 1.000001907348633 1.000001907348633 4.586721420288086 1.000001907348633 8.995402336120605 L 1.000001907348633 15.94638156890869 C 1.000001907348633 20.35506248474121 4.586721420288086 23.94178199768066 8.995402336120605 23.94178199768066 L 15.94638156890869 23.94178199768066 C 20.35506248474121 23.94178199768066 23.94178199768066 20.35506248474121 23.94178199768066 15.94638156890869 L 23.94178199768066 8.995402336120605 C 23.94178199768066 4.586721420288086 20.35506248474121 1.000001907348633 15.94638156890869 1.000001907348633 L 8.995402336120605 1.000001907348633 M 8.995402336120605 1.9073486328125e-06 L 15.94638156890869 1.9073486328125e-06 C 20.9144115447998 1.9073486328125e-06 24.94178199768066 4.027372360229492 24.94178199768066 8.995402336120605 L 24.94178199768066 15.94638156890869 C 24.94178199768066 20.9144115447998 20.9144115447998 24.94178199768066 15.94638156890869 24.94178199768066 L 8.995402336120605 24.94178199768066 C 4.027372360229492 24.94178199768066 1.9073486328125e-06 20.9144115447998 1.9073486328125e-06 15.94638156890869 L 1.9073486328125e-06 8.995402336120605 C 1.9073486328125e-06 4.027372360229492 4.027372360229492 1.9073486328125e-06 8.995402336120605 1.9073486328125e-06 Z"
                stroke="none"
                fill="#eb3a44"
              />
            </g>
          </g>
          <path
            id="Union_55"
            data-name="Union 55"
            d="M7.708,9.992,5.233,7.517,2.759,9.992A1.615,1.615,0,0,1,.474,7.708L2.949,5.233.473,2.758A1.615,1.615,0,0,1,2.758.473L5.233,2.949,7.709.473A1.615,1.615,0,0,1,9.993,2.758L7.518,5.233,9.993,7.708A1.615,1.615,0,0,1,7.708,9.992Z"
            transform="translate(7.36 7.127)"
            fill="#eb3a44"
          />
        </svg>
        <h2 class="f-16 regular">{{ item.title }}</h2>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    tab: Object,
    tab_index: Number,
  },
};
</script>

<style lang="scss">
.package-new {
  &__x {
    // position: absolute;
    width: 25px;
    height: 25px;
    top: 0;
    left: 0;
  }
  &__tab {
    position: relative;
    width: 254px;
    border-right: 1px solid #dcdcdc;
    border-top: 1px solid #dcdcdc;
    border-bottom: 1px solid #dcdcdc;

    &.first-tab {
      position: relative;
      width: 353px;
      border-left: 1px solid #dcdcdc;

      .package-new__row {
        position: relative;
        padding-left: 16px;
        padding-right: 26px;
      }
    }
    &.two_cols {
      width: 379px;
      .package-new__row {
        padding-left: 150px;
      }
      &.first-tab {
        .package-new__row {
          padding-left: 20px;
        }
      
      }
        .first-tab-row{
          padding-left: 20px !important;
        }
    }
    &--checkbox {
      // position: absolute;
      position: relative;
      width: 25px;
      height: 25px;
      top: 0;
      left: 0;
      // margin-right: 16px;
      &.checked {
        &:after {
          opacity: 1;
        }
      }
      &:after {
        opacity: 0;
        content: "";
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: url("../../assets/imgs/checkbox.png");
        background-size: 100% 100%;
      }

      &:before {
        content: "";
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: url("../../assets/imgs/checkbox_unchecked.png");
        background-size: 100% 100%;
      }
    }
  }

  &__row {
    position: relative;
    height: 117px;
    &.first-tab-row {
      padding-left: 20px;
      padding-right: 20px;
      &:after {
        box-shadow: 0px 3px 10px rgba(0, 0, 0, 0.1);
        content: "";
        position: absolute;
        bottom: 0;
        opacity: 0.3;
        left: 0;
        width: 100%;
        height: 26px;
      }
    }
    &.other-tab-row {
      padding-left: 99px;
    }
    .flex {
      h2 {
        margin-left: 16px;
      }
    }
  }

}
  @media (max-width: 1206px) and (min-width: 1024px){
    .package-new__tab.first-tab .package-new__row{
      padding-left: 0px;
      padding-right: 10px;
    }
    .package-new__tab.first-tab{
      width: 300px;
    }
    .package-new__row.other-tab-row{
      padding-left: 75px;
    }
    .package-new__tab{
      // width: 150px;
      // width: 27.311827956989248;
    }
  }
</style>
